import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';

import { FilterIcon } from '@motorway/motorway-storybook-cra';

import Badge from 'Components/shared/Badge/Badge';
import IconButtonWidthBadge from 'Components/shared/IconButton/IconButtonWithBadge';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import useVehicleFilterStore from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import styles from './VehicleListFiltersButton.module.scss';

T.setTexts(require('Components/texts.json'));

const VehicleListFiltersButton = ({ className = '', onFilterButtonClick, touched = true }) => {
	const {
		minWidth: { breakpointContent: isDesktop },
	} = useBreakpoint();
	const activeFiltersCount = useVehicleFilterStore((store) => store.valueCount);

	return (
		<>
			{!isDesktop ? (
				<IconButtonWidthBadge
					badgeText={activeFiltersCount > 0 ? activeFiltersCount : null}
					className={styles.filterButton}
					icon={<FilterIcon />}
					onClick={onFilterButtonClick}
				/>
			) : (
				<button
					className={cx(
						'mw-button mw-theme-dark mw-button-secondary mw-list-button',
						styles.vehicleListFiltersButton,
						{ [styles.preventFocus]: touched },
						className,
					)}
					onClick={onFilterButtonClick}
					type="button"
				>
					<div className={styles.vehicleListFiltersButtonText}>
						{activeFiltersCount === 0 && (
							<div className={cx('mw-button-icon', styles.activeFiltersCount)}>
								<FilterIcon />
							</div>
						)}
						<span className={styles.vehicleListFiltersButtonLabel}>{T.translate('vehicleList.filterLabel')}</span>
						{activeFiltersCount > 0 && (
							<Badge className={styles.vehicleListFiltersButtonCounter}>{activeFiltersCount}</Badge>
						)}
					</div>
				</button>
			)}
		</>
	);
};

export default VehicleListFiltersButton;

VehicleListFiltersButton.propTypes = {
	className: PropTypes.string,
	onFilterButtonClick: PropTypes.func.isRequired,
	touched: PropTypes.bool,
};
